var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPageIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.5 2.125C2.15625 2.125 1.875 2.40625 1.875 2.75V15.25C1.875 15.5938 2.15625 15.875 2.5 15.875H11.25V12.75C11.25 12.0586 11.8086 11.5 12.5 11.5H15.625V2.75C15.625 2.40625 15.3438 2.125 15 2.125H2.5ZM11.25 17.75H2.5C1.12109 17.75 0 16.6289 0 15.25V2.75C0 1.37109 1.12109 0.25 2.5 0.25H15C16.3789 0.25 17.5 1.37109 17.5 2.75V11.5V11.7148C17.5 12.3789 17.2383 13.0156 16.7695 13.4844L13.2344 17.0195C12.7656 17.4883 12.1289 17.75 11.4648 17.75H11.25Z",
    fill: "#666666"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPageIcon);
export default __webpack_public_path__ + "static/media/page_icon.43d4e15a6e455acf19a300a01c157586.svg";
export { ForwardRef as ReactComponent };